
import Vue from "vue";
import Page from "@/components/Page.vue";

export default Vue.extend({
  name: "App",
  components: {
    Page
  },
  data() {
    return {
      type: "" as string | null
    };
  },
  computed: {
    nav: function(): any {
      return new Map([
        ["stammdaten", "Stammdaten"],
        ["hauptwerte", "Hauptwerte"],
        [
          "quell",
          this.type == "Grundwasserstände"
            ? "Grundwasserstände"
            : "Quellschüttungen"
        ],
        ["analysen", "Analysen"],
        ["zeitreihen", "Zeitreihen"],
        ["download", "Download"]
      ]);
    }
  }
});
